/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodCategory } from './PaymentMethodCategory';
import {
    PaymentMethodCategoryFromJSON,
    PaymentMethodCategoryFromJSONTyped,
    PaymentMethodCategoryToJSON,
    PaymentMethodCategoryToJSONTyped,
} from './PaymentMethodCategory';
import type { PaymentMethodConfiguration } from './PaymentMethodConfiguration';
import {
    PaymentMethodConfigurationFromJSON,
    PaymentMethodConfigurationFromJSONTyped,
    PaymentMethodConfigurationToJSON,
    PaymentMethodConfigurationToJSONTyped,
} from './PaymentMethodConfiguration';
import type { PayoutSource } from './PayoutSource';
import {
    PayoutSourceFromJSON,
    PayoutSourceFromJSONTyped,
    PayoutSourceToJSON,
    PayoutSourceToJSONTyped,
} from './PayoutSource';

/**
 * 
 * @export
 * @interface LocationPaymentMethodDto
 */
export interface LocationPaymentMethodDto {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof LocationPaymentMethodDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof LocationPaymentMethodDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {string}
     * @memberof LocationPaymentMethodDto
     */
    paymentMethodDisplayLabel: string;
    /**
     * 
     * @type {PaymentMethodCategory}
     * @memberof LocationPaymentMethodDto
     */
    paymentMethodCategory: PaymentMethodCategory;
    /**
     * 
     * @type {PayoutSource}
     * @memberof LocationPaymentMethodDto
     */
    payoutSource: PayoutSource;
    /**
     * 
     * @type {Array<FavritApp>}
     * @memberof LocationPaymentMethodDto
     */
    enabledInApps: Array<FavritApp>;
    /**
     * 
     * @type {PaymentMethodConfiguration}
     * @memberof LocationPaymentMethodDto
     */
    _configuration: PaymentMethodConfiguration;
}



/**
 * Check if a given object implements the LocationPaymentMethodDto interface.
 */
export function instanceOfLocationPaymentMethodDto(value: object): value is LocationPaymentMethodDto {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentMethodDisplayLabel' in value) || value['paymentMethodDisplayLabel'] === undefined) return false;
    if (!('paymentMethodCategory' in value) || value['paymentMethodCategory'] === undefined) return false;
    if (!('payoutSource' in value) || value['payoutSource'] === undefined) return false;
    if (!('enabledInApps' in value) || value['enabledInApps'] === undefined) return false;
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    return true;
}

export function LocationPaymentMethodDtoFromJSON(json: any): LocationPaymentMethodDto {
    return LocationPaymentMethodDtoFromJSONTyped(json, false);
}

export function LocationPaymentMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationPaymentMethodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'paymentMethodDisplayLabel': json['paymentMethodDisplayLabel'],
        'paymentMethodCategory': PaymentMethodCategoryFromJSON(json['paymentMethodCategory']),
        'payoutSource': PayoutSourceFromJSON(json['payoutSource']),
        'enabledInApps': ((json['enabledInApps'] as Array<any>).map(FavritAppFromJSON)),
        '_configuration': PaymentMethodConfigurationFromJSON(json['configuration']),
    };
}

export function LocationPaymentMethodDtoToJSON(json: any): LocationPaymentMethodDto {
    return LocationPaymentMethodDtoToJSONTyped(json, false);
}

export function LocationPaymentMethodDtoToJSONTyped(value?: LocationPaymentMethodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'paymentMethodDisplayLabel': value['paymentMethodDisplayLabel'],
        'paymentMethodCategory': PaymentMethodCategoryToJSON(value['paymentMethodCategory']),
        'payoutSource': PayoutSourceToJSON(value['payoutSource']),
        'enabledInApps': ((value['enabledInApps'] as Array<any>).map(FavritAppToJSON)),
        'configuration': PaymentMethodConfigurationToJSON(value['_configuration']),
    };
}

